import {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useCompareParams} from '../CompareContent';
import {useUniversityFindQueryConfig} from '../../../../query/University/Query';
import {useCompareCostsQueryConfig} from '../../../../query/Compare/Query';
import CompareCostsContent from './CompareCostsContent';

const CompareCosts: FunctionComponent = () => {
    const [universityIds] = useCompareParams();

    const [universityFindConfig] = useUniversityFindQueryConfig(universityIds);
    const [compareCostsConfig] = useCompareCostsQueryConfig(universityIds);

    const universityFindQuery = useQuery(universityFindConfig);
    const compareCostsQuery = useQuery(compareCostsConfig);

    return (
        <Page className={'compare-page'}>
            { (universityFindQuery.data && compareCostsQuery.data) &&
                <CompareCostsContent
                    universities={universityFindQuery.data}
                    parts={compareCostsQuery.data} />
            }
        </Page>
    );
};

export default CompareCosts;
